import React from 'react';

interface Props {
  fallback: React.ReactNode;
  readonly children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/*
Existing error type:
    1. Inline comment offset error
    2. When there's code block in the content
        Uncaught Error: flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.
        This is possibly caused by using addNodeView in CodeBlock extension which is a known issue for tiptap.
        It doesn't impact when the user is editing the content. It only throws the error when user saves the content.
        Ref link: https://github.com/ueberdosis/tiptap/issues/3580, https://github.com/ueberdosis/tiptap/issues/3764
*/

class ErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // TODO: can add error logging to RUM
  // componentDidCatch(error, info) {
  // Example "componentStack":
  //   in ComponentThatThrows (created by App)
  //   in ErrorBoundary (created by App)
  //   in div (created by App)
  //   in App
  // logErrorToMyService(error, info.componentStack);
  //   }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
